export const name = 'pageContextService' as const
export const VIEWER_SERVICE_PACKAGE_NAME = '@wix/viewer-service-page-context' as const
